import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideUp = keyframes`
  from { transform: translateY(50px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeIn} 0.3s ease;
`;

export const ModalContainer = styled.div`
  background: #1e1e1e;
  width: 90%;
  max-width: 800px;
  border-radius: 12px;
  border: 1px solid #e6aa3a;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  animation: ${slideUp} 0.4s ease;
  overflow: hidden;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  position: relative; /* Para posicionar sub-modais absolutos se necessário */
`;

export const ModalHeader = styled.div`
  background: #111;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #333;

  h2 {
    margin: 0;
    color: #e6aa3a;
    font-size: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  button {
    background: transparent;
    border: none;
    color: #fff;
    font-size: 24px;
    cursor: pointer;
    &:hover {
      color: #e6aa3a;
    }
  }
`;

export const ModalBody = styled.div`
  padding: 30px;
  overflow-y: auto;
  color: #ddd;

  h3 {
    color: #fff;
    border-bottom: 1px solid #333;
    padding-bottom: 10px;
    margin-bottom: 20px;
    margin-top: 30px;

    &:first-child {
      margin-top: 0;
    }
  }
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-size: 12px;
    color: #888;
    margin-bottom: 4px;
    text-transform: uppercase;
  }

  span {
    font-size: 16px;
    color: #fff;
    font-weight: 500;

    &.highlight {
      color: #e6aa3a;
      font-weight: 700;
    }
  }
`;

export const ActionsSection = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 15px;
  margin-top: 20px;
`;

export const ActionButton = styled.button`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  padding: 15px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  transition: all 0.3s;
  font-weight: 600;

  svg {
    font-size: 20px;
    color: #e6aa3a;
  }

  &:hover {
    background: #e6aa3a;
    color: #111;
    border-color: #e6aa3a;

    svg {
      color: #111;
    }
  }
`;

/* --- ESTILOS PARA OS SUB-MODAIS (LUCRO E DATAS) --- */
export const SubFormContainer = styled.div`
  background: rgba(30, 30, 30, 0.98);
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e6aa3a;
  margin-top: 20px;
  animation: ${slideUp} 0.3s ease;

  h4 {
    margin-top: 0;
    color: #e6aa3a;
    margin-bottom: 15px;
  }
`;

export const InputGroup = styled.div`
  margin-bottom: 15px;

  label {
    display: block;
    font-size: 12px;
    color: #ccc;
    margin-bottom: 5px;
  }

  input {
    width: 100%;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #444;
    background: #111;
    color: #fff;
    outline: none;
    box-sizing: border-box;

    &:focus {
      border-color: #e6aa3a;
    }
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;

  button {
    padding: 8px 16px;
    border-radius: 4px;
    border: none;
    font-weight: 600;
    cursor: pointer;
    transition: 0.2s;

    &.cancel {
      background: #333;
      color: #fff;
      &:hover {
        background: #444;
      }
    }

    &.confirm {
      background: #e6aa3a;
      color: #000;
      &:hover {
        filter: brightness(1.1);
      }
    }

    &.delete {
      background: #ef4444;
      color: #fff;
      &:hover {
        background: #dc2626;
      }
    }
  }
`;

export const DateList = styled.div`
  max-height: 200px;
  overflow-y: auto;
  background: #111;
  border: 1px solid #333;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 15px;
`;

export const DateItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  border-bottom: 1px solid #222;

  &:last-child {
    border-bottom: none;
  }

  label {
    cursor: pointer;
    flex: 1;
    font-size: 14px;
    color: #ddd;
  }

  input[type="checkbox"] {
    accent-color: #e6aa3a;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
`;
